import * as broncos from './broncos'
import * as bulldogs from './bulldogs'
import * as cowboys from './cowboys'
import * as dragons from './dragons'
import * as eels from './eels'
import * as knights from './knights'
import * as panthers from './panthers'
import * as rabbitohs from './rabbitohs'
import * as raiders from './raiders'
import * as roosters from './roosters'
import * as sea_eagles from './sea-eagles'
import * as sharks from './sharks'
import * as storm from './storm'
import * as tigers from './tigers'
import * as west_tigers from './tigers'
import * as titans from './titans'
import * as warriors from './warriors'

export default {
  broncos,
  bulldogs,
  cowboys,
  dragons,
  eels,
  knights,
  panthers,
  rabbitohs,
  raiders,
  roosters,
  sea_eagles,
  sharks,
  storm,
  tigers,
  west_tigers,
  titans,
  warriors,
}



// WEBPACK FOOTER //
// ./src/nrl-teams/index.js